import { useAuth } from "@/context/AuthContext";

/**
 * Renders children only when the current user holds `permission`.
 * Optional `fallback` renders otherwise.
 */
export default function PermissionGate({ permission, children, fallback = null }) {
  const { hasPermission } = useAuth();
  if (!permission) return children;
  return hasPermission(permission) ? children : fallback;
}
